import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, TrendingUp, Target, DollarSign } from 'lucide-react';
import { Button } from '../../components/ui/Button';
export function ZRoofing() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="w-full pt-24 pb-24 bg-engage-black min-h-screen" data-id="element-566">
      <div className="max-w-6xl mx-auto px-4" data-id="element-567">
        {/* Back Link */}
        <Link to="/case-studies" className="inline-flex items-center text-engage-gray4 hover:text-engage-yellow transition-colors mb-12 font-medium" data-id="element-568">
          <ArrowLeft className="w-4 h-4 mr-2" data-id="element-569" />
          Back to Case Studies
        </Link>

        {/* Hero */}
        <div className="mb-16 max-w-4xl" data-id="element-570">
          <div className="flex flex-wrap gap-3 mb-6" data-id="element-571">
            <span className="px-4 py-1.5 bg-engage-yellow/10 text-engage-yellow border border-engage-yellow/20 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-572">
              Local Service
            </span>
            <span className="px-4 py-1.5 bg-engage-gray2 text-engage-gray5 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-573">
              Brand Authority
            </span>
            <span className="px-4 py-1.5 bg-engage-gray2 text-engage-gray5 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-574">
              Ads
            </span>
          </div>
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-black text-engage-white tracking-tight mb-4" data-id="element-575">
            Z Roofing and Waterproofing
          </h1>
          <h2 className="text-2xl md:text-3xl text-engage-gray4 font-medium leading-tight" data-id="element-576">
            From Invisible to Trusted: Building a Local Authority Brand
          </h2>
        </div>

        {/* Key Results Stats */}
        <div className="mb-16" data-id="element-577">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-578">
            <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 relative overflow-hidden group hover:border-engage-yellow/50 transition-colors" data-id="element-579">
              <div className="absolute top-0 right-0 p-6 opacity-5 group-hover:opacity-10 transition-opacity" data-id="element-580">
                <TrendingUp className="w-24 h-24 text-engage-yellow" data-id="element-581" />
              </div>
              <div className="relative z-10 flex flex-col h-full justify-between" data-id="element-582">
                <div className="w-12 h-12 bg-engage-black border border-engage-gray2 rounded-xl flex items-center justify-center mb-6" data-id="element-583">
                  <TrendingUp className="w-6 h-6 text-engage-yellow" data-id="element-584" />
                </div>
                <div data-id="element-585">
                  <div className="text-4xl md:text-5xl font-black text-engage-white mb-2 tracking-tight" data-id="element-586">
                    200%
                  </div>
                  <div className="text-engage-gray4 font-medium uppercase tracking-wider text-sm" data-id="element-587">
                    Lead Increase
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 relative overflow-hidden group hover:border-engage-yellow/50 transition-colors" data-id="element-588">
              <div className="absolute top-0 right-0 p-6 opacity-5 group-hover:opacity-10 transition-opacity" data-id="element-589">
                <Target className="w-24 h-24 text-engage-yellow" data-id="element-590" />
              </div>
              <div className="relative z-10 flex flex-col h-full justify-between" data-id="element-591">
                <div className="w-12 h-12 bg-engage-black border border-engage-gray2 rounded-xl flex items-center justify-center mb-6" data-id="element-592">
                  <Target className="w-6 h-6 text-engage-yellow" data-id="element-593" />
                </div>
                <div data-id="element-594">
                  <div className="text-4xl md:text-5xl font-black text-engage-white mb-2 tracking-tight" data-id="element-595">
                    #1
                  </div>
                  <div className="text-engage-gray4 font-medium uppercase tracking-wider text-sm" data-id="element-596">
                    Local Market Share
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 relative overflow-hidden group hover:border-engage-yellow/50 transition-colors" data-id="element-597">
              <div className="absolute top-0 right-0 p-6 opacity-5 group-hover:opacity-10 transition-opacity" data-id="element-598">
                <DollarSign className="w-24 h-24 text-engage-yellow" data-id="element-599" />
              </div>
              <div className="relative z-10 flex flex-col h-full justify-between" data-id="element-600">
                <div className="w-12 h-12 bg-engage-black border border-engage-gray2 rounded-xl flex items-center justify-center mb-6" data-id="element-601">
                  <DollarSign className="w-6 h-6 text-engage-yellow" data-id="element-602" />
                </div>
                <div data-id="element-603">
                  <div className="text-4xl md:text-5xl font-black text-engage-white mb-2 tracking-tight" data-id="element-604">
                    5x
                  </div>
                  <div className="text-engage-gray4 font-medium uppercase tracking-wider text-sm" data-id="element-605">
                    ROI on Ad Spend
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Content Sections */}
        <div className="space-y-10" data-id="element-606">
          {/* The Challenge */}
          <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 md:p-12" data-id="element-607">
            <h3 className="text-2xl md:text-3xl font-bold text-engage-white mb-3" data-id="element-608">
              The Challenge
            </h3>
            <div className="w-16 h-1 bg-engage-yellow rounded-full mb-6" data-id="element-609" />
            <p className="text-engage-gray4 text-base md:text-lg leading-relaxed" data-id="element-610">
              Z Roofing operated in a highly competitive local market where
              trust determines who wins the job. Despite delivering quality
              work, their online presence lacked consistency and
              professionalism, making it difficult to stand out. The gap between
              real-world results and digital perception limited their ability to
              convert potential customers.
            </p>
          </div>

          {/* Our Approach & The Result */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-611">
            <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 md:p-10 relative overflow-hidden" data-id="element-612">
              <div className="absolute top-0 right-0 w-40 h-40 bg-[radial-gradient(circle_at_top_right,rgba(252,198,13,0.12)_0%,transparent_70%)]" data-id="element-613" />
              <div className="relative z-10" data-id="element-614">
                <h3 className="text-2xl md:text-3xl font-bold text-engage-white mb-3" data-id="element-615">
                  Our Approach
                </h3>
                <div className="w-16 h-1 bg-engage-yellow rounded-full mb-6" data-id="element-616" />
                <p className="text-engage-gray4 text-base md:text-lg leading-relaxed" data-id="element-617">
                  We built a content system focused on consistency, visual
                  proof, and brand elevation. By showcasing real projects,
                  refining presentations, and maintaining a steady publishing
                  rhythm, we transformed their social presence into a
                  trust-building asset. Every piece of content was designed to
                  reinforce credibility and support the sales process.
                </p>
              </div>
            </div>
            <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 md:p-10 relative overflow-hidden" data-id="element-618">
              <div className="absolute top-0 right-0 w-40 h-40 bg-[radial-gradient(circle_at_top_right,rgba(252,198,13,0.12)_0%,transparent_70%)]" data-id="element-619" />
              <div className="relative z-10" data-id="element-620">
                <h3 className="text-2xl md:text-3xl font-bold text-engage-white mb-3" data-id="element-621">
                  The Result
                </h3>
                <div className="w-16 h-1 bg-engage-yellow rounded-full mb-6" data-id="element-622" />
                <p className="text-engage-gray4 text-base md:text-lg leading-relaxed" data-id="element-623">
                  The brand evolved into a more polished and trustworthy
                  presence, aligning its online image with the quality of its
                  work. With consistent, high-quality content, Z Roofing now
                  operates with a digital presence that builds confidence before
                  the first interaction{'\u2014'}supporting stronger conversions
                  and long-term growth.
                </p>
              </div>
            </div>
          </div>

          {/* Testimonial */}
          <div className="bg-engage-gray1 border border-engage-gray2 p-10 md:p-16 lg:p-20 rounded-2xl relative overflow-hidden text-center" data-id="element-624">
            <div className="flex justify-center mb-8" data-id="element-625">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" className="text-engage-yellow" data-id="element-626">
                <path d="M14.017 21L16.411 14.182C16.411 14.182 15.045 14.182 15.045 10.773C15.045 7.36364 18.006 5 21 5C23.994 5 24 7.36364 24 7.36364C24 7.36364 22.634 7.36364 22.634 10.773C22.634 14.182 19.909 21 19.909 21H14.017ZM3.017 21L5.411 14.182C5.411 14.182 4.045 14.182 4.045 10.773C4.045 7.36364 7.006 5 10 5C12.994 5 13 7.36364 13 7.36364C13 7.36364 11.634 7.36364 11.634 10.773C11.634 14.182 8.909 21 8.909 21H3.017Z" data-id="element-627" />
              </svg>
            </div>
            <blockquote className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-medium italic text-engage-white mb-10 md:mb-12 leading-relaxed relative z-10 max-w-4xl mx-auto" data-id="element-628">
              We didn{'\u2019'}t change the work{'\u2014'}we changed how people
              see it. And that changed everything.
            </blockquote>
            <div className="flex flex-col items-center relative z-10" data-id="element-629">
              <img src="https://cdn.magicpatterns.com/uploads/3Ab7qTKH2BWMBWASWsKWtB/Z_Roofing_and_Waterproofing-CS.png" alt="Z Roofing and Waterproofing" className="w-16 h-16 md:w-20 md:h-20 rounded-full mb-4 border-2 border-engage-gray2 object-cover" data-id="element-630" />
              <div className="font-bold text-engage-white text-lg" data-id="element-631">
                Z Roofing Team
              </div>
              <div className="text-engage-yellow font-medium text-sm uppercase tracking-wider" data-id="element-632">
                Owner, Z Roofing and Waterproofing
              </div>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="mt-20 text-center bg-engage-gray1 border border-engage-gray2 rounded-2xl p-12 md:p-20 relative overflow-hidden" data-id="element-633">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(252,198,13,0.08)_0%,transparent_100%)]" data-id="element-634" />
          <div className="relative z-10 max-w-4xl mx-auto" data-id="element-635">
            <h2 className="text-3xl md:text-5xl font-black mb-6 tracking-tight" data-id="element-636">
              Ready to Build Your Growth Engine?
            </h2>
            <p className="text-engage-gray4 text-xl mb-10" data-id="element-637">
              Stop guessing with your marketing budget. Let's build a
              predictable system for your brand.
            </p>
            <Button to="/contact" variant="primary" className="text-lg px-12 py-5" data-id="element-638">
              Book a Call With Us
            </Button>
          </div>
        </div>
      </div>
    </div>;
}